import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';
import axFile from 'src/store/configFile';


const initialState = {
    trainingList: null,
    trainingListLoading: false
};

export const trainingAction = createAsyncThunk('trainingAction', async (payload, { dispatch }) => {
    dispatch(setTrainingListLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/employType';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setTrainingListLoading(false))
                return data

            case 'post':
                ({ data } = await axFile.post(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Тренировка успешно отредактирована`
                })
                break;

            case 'put':
                ({ data } = await axFile.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Тренировка успешно добавлена`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Тренировка успешно удалена`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setTrainingListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

const TrainingsSlice = createSlice({
    name: 'training',
    initialState,
    reducers: {
        setTrainingListLoading: (state, action) => {
            state.trainingListLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(trainingAction.fulfilled, (state, action) => {
            state.trainingList = action.payload
        })
    }
});

export const { setTrainingListLoading } = TrainingsSlice.actions;

export default TrainingsSlice.reducer